/**
 * Where an organization decides whether batches need a second approver. Its own file so the payout batches
 * module can point here without importing the Settings page.
 */
export const PAYOUT_BATCH_APPROVAL_SECTION_ID = "pagos-por-lote";

export const PAYOUT_BATCH_APPROVAL_SETTINGS_PATH = `/app/settings?section=${PAYOUT_BATCH_APPROVAL_SECTION_ID}`;
